import { render } from "./view_customer.html?vue&type=template&id=acbbbb5e&external"
import script from "./view_customer.js?vue&type=script&lang=js&external"
export * from "./view_customer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__